import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { capturePageview } from "analytics/posthog";

// Manual $pageview capture on every route change (capture_pageview is off in
// init). Mounted inside <BrowserRouter> via App.tsx.
export default function PostHogPageview() {
  const location = useLocation();

  useEffect(() => {
    capturePageview();
  }, [location.pathname, location.search]);

  return null;
}
